export const PANEL_WIDTH = 980;

export const panelStylesProp = {
  footer: {
    backgroundColor: '#FFFFFF',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    overflowX: 'hidden',
    paddingLeft: 24,
    paddingRight: 24,
  },
};

// adjust for shell
export const panelStyles = {
  top: 60,
};

export const layerProps = {
  styles: {
    root: { zIndex: 1000 }, // adjust lower as z-index of help popup is 1100
  },
  eventBubblingEnabled: true,
};
